'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgDownload(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8.463 5.259v2.764l-.04.836.283-.32.74-.83a.437.437 0 01.323-.146c.255 0 .444.181.444.432 0 .14-.054.237-.148.328l-1.736 1.721c-.121.126-.222.168-.35.168-.12 0-.222-.042-.343-.168L5.894 8.323a.444.444 0 01-.142-.328c0-.25.182-.432.438-.432.114 0 .242.049.33.146l.74.83.282.32-.04-.836V5.259h.961zM4.965 14H11c1.15 0 1.715-.586 1.715-1.757V7.015c0-1.17-.565-1.756-1.715-1.756H4.965c-1.143 0-1.715.585-1.715 1.756v5.228c0 1.171.572 1.757 1.715 1.757zm3.49-8.744V2.62c0-.341-.214-.62-.475-.62-.256 0-.47.279-.47.62v2.636h.946z", fill: "currentColor" }))));
}

module.exports = SvgDownload;
//# sourceMappingURL=Download.js.map
